"use strict";

import React, { Component, PropTypes } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { WidgetActions, SessionActions, AlertActions } from '../../../actions';
import UserSearch from '../../User-Search';
class AddManager extends Component{
  constructor() {
    super();

    this.state = {
      canSubmit: false,
      selectedUser:[]
    };

    this._handleSubmit = this._handleSubmit.bind(this);
    this._handleClose = this._handleClose.bind(this);
  };

  static propTypes = {
    open: PropTypes.bool.isRequired
  };
  _handleClose() {
    if(typeof this.props.onClose === 'function') {
      this.props.onClose();
    }
  };
  render() {
    return(
      <Modal show={this.props.open} backdrop={true} >
        <Modal.Header closeButton={true} onHide={this._handleClose}>
          <Modal.Title>{this.props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>

        <UserSearch onSelection={user => this.setState({selectedUser:user}) } />

        </Modal.Body>
        <Modal.Footer>
          <div>
            <Button bsStyle="primary"
                    disabled={!this.state.selectedUser.length}
                    onClick={(e)=>this._handleSubmit(e)}>
              Submit
            </Button>
            <Button className="m-l-5p" type="submit" bsStyle="default"
                    onClick={()=>this.props.onClose()}>
              Cancel
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    )
  };

  _handleSubmit(e) {
    e.preventDefault();
    this.props.onSubmit(this.state.selectedUser._id);
    this.props.onClose();
  };
}

export default AddManager;
